import React from 'react';

interface EmptyProps {
	text?:string,
	value?:string,
}

const Empty:React.FC<EmptyProps> = (props)=> {
	let text = 'なし';
	if( props.text ){
		text = props.text;
	}
	if( props.value ){
		if( props.value!=='' ){
			return (<>{props.value}</>);
		}
	}
	return (
		<div style={{color:'#666666'}}>{text}</div>
    );
}

export default Empty;
